import SwitchButtons from './SwitchButtons';

export default SwitchButtons;
